module.exports = __webpack_public_path__ + "static/img/bpump08.b6fe515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/bpump08.jpg
// module id = 8640
// module chunks = 0